import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
const VuexLocal = new VuexPersistence({
  storage: window.localStorage
}); // https://github.com/championswimmer/vuex-persist vuex的本地持久化插件

// 通用Module
import common from './module/common';
import loginModule from './module/loginModule'; 
import serviceModule from './module/serviceModule'  
import registerModule from './module/registerModule'  
import companyModule from './module/companyModule'  
import companyInfoModule from './module/companyInfoModule'  
import productModule from './module/productModule'
import productFeedbackModule from './module/productFeedbackModule'
import releaseModule from './module/releaseModule'
import momentModule from './module/momentModule'

import activityModule from './module/activityModule' 
import activityModuleNew from './module/activityModuleNew' 
import materialModule from './module/materialModule'  
import exhibitionModule from './module/exhibitionModule'  // 展会模块
import bannerModule from './module/bannerModule'  // banner模块
import albumModule from './module/albumModule'  // 图集模块
import customComponentModule from './module/customComponentModule'  // 自定义组件模块
import customCompanyModule from './module/customCompanyModule'  // 自定义组件模块
import categoryModule from './module/categoryModule'  // 自定义组件模块
// 组件Module

// 主办Module 
import hostSetModule from './module/host/hostSetModule'  // 主办设置
import hostActModule from './module/host/hostActModule'  // 主办活动
import hostAuditModule from './module/host/hostAuditModule'  // 主办活动
import hostCommonModule from './module/host/hostCommonModule'  // 主办活动
import hostDownModule from './module/host/hostDownModule'  // 主办活动
import hostNeed from './module/host/hostNeed'  // 主办活动
import webKindModule from './module/host/webKindModule'  // 主办活动

import registerdModule from './module/register/registerdModule'  // 展商注册

const Modele = {
  loginModule, 
  serviceModule,
  registerModule, 
  companyModule,
  companyInfoModule,
  activityModule,
  activityModuleNew,
  materialModule,
  productModule,
  productFeedbackModule,
  releaseModule,
  exhibitionModule,
  bannerModule,
  albumModule,
  customComponentModule,
  customCompanyModule,
  momentModule,
  categoryModule,
  registerdModule,
};

const hostModele = {
  hostSetModule,
  hostActModule,
  hostAuditModule,
  hostCommonModule,
  hostDownModule,
  hostNeed,
  webKindModule,
};

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...common.state, // 通用 state 
  },
  getters: {
    ...common.getters, // 通用 getters  
  },
  mutations: {
    ...common.mutations, // 通用 mutations 
  },
  modules: {
    ...Modele,
    ...hostModele,
  },
  actions: {
    ...common.actions // 通用 actions
  },
  plugins: [VuexLocal.plugin]
})